import React, { FC, memo, ReactNode } from 'react';

import { Breakpoint, useBreakpoint } from '@hh.ru/magritte-ui-breakpoint';

export interface BreakpointSwitcherProps {
    default: ReactNode;
    xs?: ReactNode;
    s?: ReactNode;
    m?: ReactNode;
    l?: ReactNode;
    xl?: ReactNode;
    xxl?: ReactNode;
    gteXs?: ReactNode;
    gteS?: ReactNode;
    gteM?: ReactNode;
    gteL?: ReactNode;
    gteXl?: ReactNode;
}

const SIZES_SORTED = ['xs', 's', 'm', 'l', 'xl', 'xxl'] as const;

const getActiveComponent = (props: BreakpointSwitcherProps, activeBreakpoint: Breakpoint): ReactNode => {
    let result = props.default;
    let lastAssigned = props.default;

    for (const size of SIZES_SORTED) {
        const gteKey = `gte${size.charAt(0).toUpperCase()}${size.slice(1)}` as keyof BreakpointSwitcherProps;

        // Если текущий размер совпадает с активным, берем его
        if (size === activeBreakpoint) {
            result = props[size] ?? props[gteKey] ?? lastAssigned;
            break;
        }

        // Если встречаем gte-значение, обновляем "активное" значение
        if (props[gteKey]) {
            lastAssigned = props[gteKey];
        }
    }

    return result;
};

const BreakpointSwitcher: FC<BreakpointSwitcherProps> = memo((props) => {
    const { breakpoint: activeBreakpoint } = useBreakpoint();

    // Генерация карты размеров с учетом приоритетов

    const component = getActiveComponent(props, activeBreakpoint);

    return <>{component}</>;
});

BreakpointSwitcher.displayName = 'BreakpointSwitcher';

export default BreakpointSwitcher;
